import { Schedule } from "../../../entities";
import { BaseODataRepository } from "../../BaseODataRepository";

export class ScheduleODataRepo extends BaseODataRepository<Schedule> {
  protected baseUrl = `/OData/schedules`;
}

export default ScheduleODataRepo;
